<template>
  <v-main>
    <v-container class="fill-height loginPage">
       <img class="imageHeader" src="@/assets/loogo-.png" :alt="$t('navbar.title')" />
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="4" lg="6">
          <v-card color="basil">
            <v-toolbar color="primary" dark flat>
              <v-tabs
                v-model="tab"
                background-color="transparent"
                color="basil"
                grow
              >
                <v-tab> {{ $t("auth.login.title") }} </v-tab>

                <v-tab> {{ $t("auth.register.title") }} </v-tab>
              </v-tabs>
            </v-toolbar>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-form ref="formLogin" lazy-validation>
                    <v-card-text>
                      <TextField
                        :rules="[rules.required, rules.email]"
                        :label="$t('auth.login.email')"
                        clearable
                        prepend-icon="mdi-email"
                        v-model="login.email"
                      />

                      <TextField
                        :rules="[rules.required]"
                        :label="$t('auth.login.password')"
                        clearable
                        @keyup.enter="loginUser"
                        :append-icon="
                          login.showPasswordOneRegister
                            ? 'mdi-eye'
                            : 'mdi-eye-off'
                        "
                        :type="
                          login.showPasswordOneRegister ? 'text' : 'password'
                        "
                        prepend-icon="mdi-lock"
                        v-model="login.password"
                        @click:append="
                          login.showPasswordOneRegister = !login.showPasswordOneRegister
                        "
                      />
                      <v-spacer></v-spacer>
                      <v-btn
                        color="#8bc34a"
                        class="white--text"
                        :loading="loadingLogin"
                        @click="loginUser"
                        
                        >{{ $t("auth.login.submit") }}</v-btn
                      >
                    </v-card-text>
                  </v-form>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-form ref="formRegister" lazy-validation>
                    <v-card-text>
                      <TextField
                        :rules="[rules.required]"
                        :label="$t('auth.register.firstname')"
                        clearable
                        prepend-icon="mdi-account"
                        v-model="register.firstName"
                      />
                      <TextField
                        :rules="[rules.required]"
                        :label="$t('auth.register.lastname')"
                        clearable
                        prepend-icon="mdi-account"
                        v-model="register.lastName"
                      />
                      <TextField
                        :rules="[rules.required, rules.email]"
                        :label="$t('auth.register.email')"
                        clearable
                        prepend-icon="mdi-email"
                        v-model="register.email"
                      />
                      <!-- <TextField
                        :rules="[rules.required, rules.onlyNumber]"
                        :label="$t('auth.register.phonenumber')"
                        clearable
                        prepend-icon="mdi-cellphone"
                        v-model="register.phoneNumber"
                      /> -->
                      <TextField
                        :rules="[rules.required]"
                        :label="$t('auth.register.password')"
                        clearable
                        :append-icon="
                          register.showPasswordOneRegister
                            ? 'mdi-eye'
                            : 'mdi-eye-off'
                        "
                        :type="
                          register.showPasswordOneRegister ? 'text' : 'password'
                        "
                        prepend-icon="mdi-lock"
                        v-model="register.password"
                        @click:append="
                          register.showPasswordOneRegister = !register.showPasswordOneRegister
                        "
                      />
                      <TextField
                        :rules="[rules.required, rules.paswordconfirm]"
                        :label="$t('auth.register.passwordconfirm')"
                        clearable
                        :append-icon="
                          register.showPasswordTowRegister
                            ? 'mdi-eye'
                            : 'mdi-eye-off'
                        "
                        :type="
                          register.showPasswordTowRegister ? 'text' : 'password'
                        "
                        prepend-icon="mdi-lock"
                        @click:append="
                          register.showPasswordTowRegister = !register.showPasswordTowRegister
                        "
                        v-model="register.passwordConfirm"
                      />

                      <v-btn
                        color="#8bc34a"
                        class="white--text"
                        :loading="loadingRegister"
                        @click="registerUser"
                        >{{ $t("auth.register.submit") }}</v-btn
                      >
                    </v-card-text>
                  </v-form>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>

      <template v-if="MSGLogout != undefined">
        <v-card>
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :color="color"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
          >
            {{ MSGLogout }}

            <template v-slot:action="{ attrs }">
              <v-btn dark text v-bind="attrs" @click="snackbar = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </v-card>
      </template>
    </v-container>
  </v-main>
</template>
<style scoped>
.v-main{
        padding: 00px 0px 58px !important
  }
</style>
<style>
    @media (max-width: 768px){
  .loginPage .imageHeader {
    width: 230px !important
}
  

}
  .loginPage .v-card header.v-sheet , .loginPage .v-card header .v-toolbar__content{
    height: 50px !important;
    
  }
  .loginPage .v-card header.v-sheet{
    border-radius: 5px 5px 0 0 !important;
    overflow: hidden;
  }
  .v-tabs--grow > .v-tabs-bar .v-tab.v-tab--active {
    background-color: #fb8c00;
  }
  .loginPage .imageHeader {
    max-width: 500px;
    display: block;
    margin-bottom: 20px;
    margin: auto;
  }
</style>
<script>
import axios from "axios";
import TextField from "@/components/Elements/TextField";

export default {
  name: "login",
  props: {
    source: String,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t("valid.required"),
        onlyNumber: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0) ||
          this.$t("valid.onlyNumber"),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("valid.emailInValid");
        },
        paswordconfirm: () =>
          this.register.password == this.register.passwordConfirm ||
          this.$t("valid.passwordNotConfirm"),
      },

      tab: null,
      items: ["Login", "Register"],
      login: {
        email: "",
        password: "",
        showPasswordOneRegister: false,
      },
      register: {
        showPasswordOneRegister: false,
        showPasswordTowRegister: false,
        firstName: "",
        lastName: "",
        email: "" ,
        password: "",
        passwordConfirm: "",
      },

      // Public
      loadingLogin: false,
      loadingRegister: false,

      errorShow: false,
      errorMsg: "",
      color: "primary",
      mode: "",
      snackbar: true,
      MSGLogout: "",
      timeout: 6000,
      x: null,
      y: "top",
    };
  },

  components: {
    TextField,
  },

  created: function () {
    this.MSGLogout = this.$attrs.Msg;
    if(this.$route.query.register=='true' ){
      this.tab = 1
    }
    else{
      this.tab = 0
    }
  },
  methods: {
    loginUser() {
      if (this.$refs.formLogin.validate() != false) {
        this.loadingLogin = true;
        axios
          .post(this.$store.getters.getAPI + "/login", {
            email: this.login.email,
            password: this.login.password,
          })
          .then((response) => {
            if (response.status == 200) {
              localStorage.setItem("token", response.data.data.token);
              localStorage.setItem(
                "name",
                response.data.data.User.firstname +
                  " " +
                  response.data.data.User.lastname
              );
              this.$store.commit("SetToken", response.data.data);
              this.loadingLogin = false;
              this.$router.push({ name: "Home" });
            }
          })
          .catch((error) => {
            this.loadingLogin = false;
            this.$store.dispatch("PushErrorMsg", error.response.data.message);
          });
      } else {
        this.$store.dispatch("PushErrorMsg", this.$t("valid.dataNotValid"));
      }
    },
    registerUser() {
      if (this.$refs.formRegister.validate() != false) {
        this.loadingRegister = true;
        axios
          .post(this.$store.getters.getAPI + "/signup", {
            firstname: this.register.firstName,
            lastname: this.register.lastName,
            email: this.register.email,
            phonenumber: this.register.phoneNumber,
            password: this.register.password,
            langcode : localStorage.getItem("lang") || 'ar',
            accepteconditions: 1,
          })
          .then((response) => {
            this.loadingRegister = false;
            this.$store.dispatch("PushSuccessMsg", response.data.message);
            this.tab = "Login";
            this.register.firstName = "";
            this.register.lastName = "";
            this.register.email = "";
            this.register.phoneNumber = "";
            this.register.password = "";
            this.register.passwordConfirm = "";
          })
          .catch((error) => {
            let errorObj = error.response.data.data;
            this.loadingRegister = false;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", this.$t("valid.dataNotValid"));
      }
    },
  },
};
</script>